import React from 'react';

export default class ModalForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {},
            errors: {},
            errorMessage: '',
            successMessage: '',
            loading: false,
            show: false
        }
    }

    showError(fieldName) {
        return this.state.errors.hasOwnProperty(fieldName) && this.state.errors[fieldName].length > 0 ? (
            <div className="form-control-feedback">{this.state.errors[fieldName][0]}</div>
        ) : null;
    }

    getErrorClass(fieldName) {
        return this.state.errors.hasOwnProperty(fieldName) ? 'has-danger' : '';
    }

    showErrorMessage() {
        return this.state.errorMessage ? (
            <div className="col-md-12 mt-0">
                <div className="alert alert-danger" role="alert">
                    {this.state.errorMessage}
                </div>
            </div>
        ) : null;
    }

    showSuccessMessage() {
        return this.state.successMessage ? (
            <div className="col-md-12 mt-0">
                <div className="alert alert-success" role="alert">
                    {this.state.successMessage}
                </div>
            </div>
        ) : null;
    }

    handleChange(fieldName, value, cb = null) {
        let form = this.state.form;
        form[fieldName] = value;
        this.setState({ form }, () => {
            if (cb && typeof cb === 'function') {
                cb();
            }
        });
    }

    handleSubmit() {
        //method to be implemented
    }

    toggle() {
        this.setState({ show: !this.state.show}, ()=>{
            if (this.state.show) {
                window.showRecaptcha();
            } else {
                window.hideRecaptcha();
            }
        });
        if (window.location.hash) {
            window.location.hash = '';
        }
    }

    sendAnalyticsPageView(modalhash = null) {
        if (window.env === 'production') {
            if (window.location.pathname.indexOf('reactivate-access') === -1) {
 				window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'mandyModal',
                    'modalname' : modalhash
                });
            }
        }
    }

    render() {
        return <div>Form: render Method not implemented.</div>;
    }
}
